<template lang="pug">
v-app
  v-main
    slot
</template>

<script>
export default {}
</script>

<style>
</style>
